module.exports = __webpack_public_path__ + "img/csca-logotype.a44c051f.svg";